module.exports = __webpack_public_path__ + "img/制御工学5_3.e7446188.png";